/**
 * @module FavouritesConstants
 * @requires keyMirror
 */

/**
 * @const AccountsPreferenceConstants
 */
const FavouritesConstants = {
  // Account Reorder Constants
  REQUEST_FAVOURITE_ACCOUNTS: 'REQUEST_FAVOURITE_ACCOUNTS',
  REQUEST_FAVOURITE_ACCOUNTS_SUCCESS: 'REQUEST_FAVOURITE_ACCOUNTS_SUCCESS',
  REQUEST_FAVOURITE_ACCOUNTS_FAILURE: 'REQUEST_FAVOURITE_ACCOUNTS_FAILURE',
  REQUEST_ACCOUNT_DETAILS: 'REQUEST_ACCOUNT_DETAILS_FAV',
  REQUEST_ACCOUNT_DETAILS_SUCCESS: 'REQUEST_ACCOUNT_DETAILS_FAV_SUCCESS',
  REQUEST_ACCOUNT_DETAILS_ERROR: 'REQUEST_ACCOUNT_DETAILS_FAV_ERROR',
  REQUEST_TERMS_AND_CONDITIONS: 'REQUEST_TERMS_AND_CONDITIONS_FAV',
  REQUEST_ACCEPT_TC_SUCCESS: 'REQUEST_ACCEPT_TC_SUCCESS_FAV',
  REQUEST_REJIG_POT_DETAILS_SUCCESS: 'REQUEST_REJIG_POT_DETAILS_SUCCESS_FAV',
  REQUEST_RESET_REJIG_ICON: 'REQUEST_RESET_REJIG_ICON_FAV',
  REQUEST_DANGER_PERIOD_SUCCESS: 'REQUEST_DANGER_PERIOD_SUCCESS_FAV',
  REQUEST_ACCOUNTS_RESET_ERROR: 'REQUEST_ACCOUNTS_RESET_ERROR_FAV',
  SET_ACCOUNT: 'SET_ACCOUNT_FAV',
  RESORT_ACCOUNT: 'RESORT_ACCOUNT_FAV',

  ADD_FAVOURITE_ACCOUNT: 'ADD_FAVOURITE_ACCOUNT',
  REMOVE_FAVOURITE_ACCOUNT: 'REMOVE_FAVOURITE_ACCOUNT',
  REORDER_FAVOURITE_ACCOUNTS: 'REORDER_FAVOURITE_ACCOUNTS',
  ADD_FAVOURITE_ACCOUNTS_SUCCESS: 'ADD_FAVOURITE_ACCOUNT_SUCCESS',
  ADD_FAVOURITE_ACCOUNTS_FAILURE: 'ADD_FAVOURITE_ACCOUNT_FAILURE',
  REMOVE_FAVOURITE_ACCOUNTS_SUCCESS: 'REMOVE_FAVOURITE_ACCOUNT_SUCCESS',
  REMOVE_FAVOURITE_ACCOUNTS_FAILURE: 'REMOVE_FAVOURITE_ACCOUNT_FAILURE',
  REORDER_FAVOURITE_ACCOUNTS_SUCCESS: 'REORDER_FAVOURITE_ACCOUNTS_SUCCESS',
  REORDER_FAVOURITE_ACCOUNTS_FAILURE: 'REORDER_FAVOURITE_ACCOUNTS_FAILURE',
  SET_FAVOURITE_ACCOUNTS_EXCEEDED_MAX: 'SET_FAVOURITE_ACCOUNTS_EXCEEDED_MAX',
  ADD_SELECTED_ACCOUNT: 'ADD_SELECTED_ACCOUNT',
  SET_ACCOUNT_PICKER_ACTIONS: 'SET_ACCOUNT_PICKER_ACTIONS',
  RENAME_ACCOUNT: 'RENAME_ACCOUNT',
  CLEAR_SELECTED_ACCOUNT_ID: 'CLEAR_SELECTED_ACCOUNT_ID',
  REQUEST_QUICKLINK_PERMISSIONS: 'REQUEST_QUICKLINK_PERMISSIONS',
  REQUEST_QUICKLINK_PERMISSIONS_SUCCESS:
    'REQUEST_QUICKLINK_PERMISSIONS_SUCCESS',
  RESET_ACCOUNT_DETAILS_FLAG: 'RESET_ACCOUNT_DETAILS_FLAG',
};

export default FavouritesConstants;

export const MAX_FAVOURITES = 30;

export const initialPermissions = {
  sweepsEnabled: false,
  stmtPreferenceEnabled: false,
  potsEnabled: false,
  spendingsEnabled: false,
  alertsEnabled: false,
  managePaymentsEnabled: false,
  managePayeesEnabled: false,
  isCreditCardUser: true,
  sweepsOutEnabled: false,
  paymentsEnabled: false,
};

export const initialState = {
  selectedAccount: {},
  accountList: [],
  accountDetails: [],
  accountTypeColor: [],
  favouritesLoaded: false,
  loading: false,
  showError: false,
  updated: false,
  updating: false,
  error: false,
  status: '',
  permissions: {
    ...initialPermissions,
  },
  accountsLoaded: false,
  navigationReference: '',
  termsAndConditionsFlag: false,
  accountPickerActions: {
    backUrl: '',
    onSelectAccount: undefined,
  },
  accountReorderError: false,
};
